export class WhatsappUtils {

  static textNumber(number: string) {
    const sanitizedNumber = number.replace(/\D/g, '');
    window.open(`https://wa.me/${sanitizedNumber}`, '_blank');
  }

}